"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function capitalizeFirstLetter(text) {
    return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
}
exports.capitalizeFirstLetter = capitalizeFirstLetter;



// WEBPACK FOOTER //
// ./~/@dialogexe/cw-component-ticket/utils.tsx